/* eslint-disable array-callback-return */
import { Discount, Campaign } from '../../types/discounts';

export interface ActiveCampaigns {
    id: string;
    name: string;
    timeUsed: number;
    discountGiven: number;
    started: string;
    ends: string;
    createdAt: string;
    updatedAt: string;
}

export interface ScheduledCampaigns {
    id: string;
    name: string;
    scheduled: string;
    createdAt: string;
    updatedAt: string;
}

export interface CompletedCampaigns {
    id: string;
    name: string;
    timeUsed: number;
    discountGiven: number;
    started: string;
    ended: string;
    createdAt: string;
    updatedAt: string;
}

export const getSortedCampaigns = (discounts: Discount[], campaigns: Campaign[]) => {
    const activeCampaigns: ActiveCampaigns[] = [];
    const scheduledCampaigns: ScheduledCampaigns[] = [];
    const completedCampaigns: CompletedCampaigns[] = [];

    campaigns.map(campaign => {
        if (campaign.id) {
            const { activeDiscounts, scheduledDiscounts, completedDiscounts } = collateDiscounts(discounts, campaign);
            if (activeDiscounts.length > 0) {
                let timeUsed = 0;
                let discountGiven = 0;
                activeDiscounts.map(discount => {
                    if (discount && discount.statistics) {
                        const statistics = discount.statistics;
                        timeUsed = timeUsed + statistics?.used || 0;
                        discountGiven = discountGiven + discount.statistics?.amount || 0;
                    }
                });
                activeCampaigns.push({
                    id: campaign.campaign_id ?? '',
                    name: campaign.name,
                    timeUsed,
                    discountGiven,
                    started: activeDiscounts[0].requirement.purchase_from,
                    ends: activeDiscounts[0].requirement.purchase_to,
                    createdAt: campaign.created_at || '',
                    updatedAt: campaign.updated_at || '',
                });
            }

            if (scheduledDiscounts.length > 0) {
                scheduledCampaigns.push({
                    id: campaign.campaign_id ?? '',
                    name: campaign.name,
                    scheduled: scheduledDiscounts[0].requirement.purchase_from,
                    createdAt: campaign.created_at || '',
                    updatedAt: campaign.updated_at || '',
                });
            }

            if (completedDiscounts.length > 0) {
                let timeUsed = 0;
                let discountGiven = 0;
                activeDiscounts.map(discount => {
                    if (discount.statistics) {
                        timeUsed = timeUsed + discount.statistics.used;
                        discountGiven = discountGiven + discount.statistics.amount;
                    }
                });
                completedCampaigns.push({
                    id: campaign.campaign_id ?? '',
                    name: campaign.name,
                    timeUsed,
                    discountGiven,
                    started: completedDiscounts[0].requirement.purchase_from,
                    ended: completedDiscounts[0].requirement.purchase_to,
                    createdAt: campaign.created_at || '',
                    updatedAt: campaign.updated_at || '',
                });
            }
        }
    });
    return { activeCampaigns, scheduledCampaigns, completedCampaigns };
};

const collateDiscounts = (discounts: Discount[], campaign: Campaign) => {
    const activeDiscounts: Discount[] = [];
    const scheduledDiscounts: Discount[] = [];
    const completedDiscounts: Discount[] = [];
    const currentDate = new Date().getTime();

    discounts.map(discount => {
        if (discount.campaign_id === campaign.campaign_id) {
            const fromDate = new Date(discount.requirement.purchase_from).getTime();
            const toDate = new Date(discount.requirement.purchase_to).getTime();
            if (currentDate >= fromDate && currentDate <= toDate) {
                activeDiscounts.push(discount);
            } else if (currentDate < fromDate) {
                scheduledDiscounts.push(discount);
            } else if (currentDate > toDate) {
                completedDiscounts.push(discount);
            }
        }
    });
    return { activeDiscounts, scheduledDiscounts, completedDiscounts };
};
